import React, { FC, Fragment, useEffect, useState } from 'react'
import { TextField, CircularProgress } from '@mui/material'

type OptionValue = string | number
type variant = 'standard' | 'outlined' | 'filled'
type size = 'small' | 'medium'

interface Option<T extends OptionValue> {
  value: T
}

interface AutoCompleterProps<T extends OptionValue> {
  item: Option<T>[]
  nameList: string
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  labelList: string
  isLoader: boolean
  value?: string | number | boolean
  variant?: variant
  size?: size
  fullWidth?: boolean
}

export const AutoCompleter: FC<AutoCompleterProps<OptionValue>> = ({
  item,
  nameList,
  handleChange,
  labelList,
  isLoader,
  value,
  variant = 'standard',
  size = 'small',
  fullWidth = false
}) => {
  const [items, setItems] = useState<any[]>(item)

  useEffect(() => {
    setItems(item)
  }, [onkeydown])

  return (
    <Fragment>
      <TextField
        fullWidth={fullWidth}
        autoComplete='off'
        variant={variant}
        name={`${nameList}`}
        size={size}
        label={`${labelList}`}
        onChange={(e: any) => {
          handleChange(e)
        }}
        onMouseDown={(e: any) => (e.target.value = '')}
        InputProps={{
          endAdornment: (
            <datalist
              id={`${nameList}`}
              style={{
                position: 'absolute',
                backgroundColor: 'white',
                border: '1px solid blue',
                borderRadius: '0 0 5px 5px',
                borderTop: 'none',
                width: '350px',
                padding: '5px',
                maxHeight: '10rem',
                overflowY: 'auto'
              }}
            >
              {items.length > 0
                ? items.map((opt) => (
                    <option value={opt.value}>{opt.value}</option>
                  ))
                : item.map((opt) => (
                    <option value={opt.value}>{opt.value}</option>
                  ))}
            </datalist>
          ),
          inputProps: {
            list: `${nameList}`
          }
        }}
        value={value}
      />

      {isLoader ? (
        <CircularProgress
          size={20}
          style={{ marginTop: '5px', marginLeft: '5px' }}
        />
      ) : (
        ''
      )}
    </Fragment>
  )
}
